import { render, staticRenderFns } from "./StatsVue.vue?vue&type=template&id=0e2d30a3&"
import script from "./StatsVue.vue?vue&type=script&lang=js&"
export * from "./StatsVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports